import React from "react";
import { useEffect } from "react";
import Footer from "./Footer";
import HeaderInner from "./HeaderInner";
import { useDispatch, useSelector } from "react-redux";
import configureStore from "../../../store/configureStore";
import Bill from "./common/Bill";
import { history } from "../../../reducers";
import Loader from "../../common/Loader";
import { get_orgunit_details } from "../../../actions/action-orgunit";
import { get_transaction_details } from "./actions/action-transactions";
import NewBill from "./common/NewBill";


const store = configureStore();

function PaymentReceivedDetails() {
  const dispatch = useDispatch();
  const { activeOuid } = store.getState().permission;
  const { transactionDetails, showGlobalLoader } = useSelector(
    (state) => state.transactions
  );
  const { OrgunitDetails } = useSelector((state) => state.orgunit);

  useEffect(() => {
    let transactionId = window.location.pathname.split("/");
    transactionId = transactionId[3];
    console.log("transactionId", transactionId);

    console.log("inuseEffect");
    const fetchData = async (dispatch) => {
      await dispatch(get_transaction_details(transactionId, activeOuid));
      await dispatch(get_orgunit_details(activeOuid));
    };
    fetchData(dispatch);
  }, [dispatch]);

  return (
    <div>
      <HeaderInner pageTitle="Purchase Invoice Details" />
      <div className="AppPage container--narrow mt FBAppPage">
        <button
          className="bill_edit_btn mb"
          onClick={() =>
            history.push(
              `/${activeOuid}/edit-purchase-invoice/${transactionDetails.id}`
            )
          }
        >
          Edit
        </button>
        {showGlobalLoader ? (
          <Loader />
        ) : (
          <>
            <NewBill
              billDetails={transactionDetails}
              companyDetails={OrgunitDetails}
            />
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default PaymentReceivedDetails;
